export default __webpack_public_path__ + "static/media/snap-photo.6436591c.png";